import React, { useState } from "react";
import {
  Button,
  Box,
  Collapse,
  Flex,
  HStack,
  Icon,
  Text,
} from "@chakra-ui/react";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { UploadFileType } from "../segmentSetupPage/segmentForm/KeywordsFile";
import { useMutation } from "@apollo/client";
import { UPDATE_PACKAGE } from "../../graphql/operations/campaignOperations/operations";
import { KeywordsUploadBox } from "./KeywordsUploadBox";
import { BsExclamationTriangleFill } from "react-icons/bs";

export interface EditKeywordsDropdownProps {
  segmentId: string;
}

export const EditKeywordsDropdown = ({
  segmentId,
}: EditKeywordsDropdownProps) => {
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState<string | null>(null);
  const [updatePackage] = useMutation(UPDATE_PACKAGE);
  const [keywordsIncFile, setKeywordsIncFile] = useState<UploadFileType>(
    {} as UploadFileType
  );

  const handleToggle = () => setShow(!show);

  return (
    <Flex direction={"column"} width="100%" mb={2}>
      <Button
        alignSelf={"flex-start"}
        fontWeight={"semibold"}
        variant="collapseDropdown"
        onClick={handleToggle}
        rightIcon={show ? <FiMinusCircle /> : <FiPlusCircle />}
      >
        Update Keywords
      </Button>
      <Collapse in={show}>
        {errors && (
          <HStack
            color={"error"}
            bg={"rgb(252, 234, 234)"}
            p={5}
            spacing={6}
            mb={4}
          >
            <Icon as={BsExclamationTriangleFill} w={10} h={10} />
            <Text fontSize={"16px"} fontWeight={"bold"}>
              {errors}
            </Text>
          </HStack>
        )}
        <Box margin={1} mb={2}>
          <KeywordsUploadBox
            keywordsIncFile={keywordsIncFile}
            setKeywordsIncFile={setKeywordsIncFile}
          />
        </Box>
        <Flex justifyContent="flex-start" ml={1}>
          <Button
            variant={"blueButton"}
            onClick={() =>
              updatePackage({
                variables: {
                  packageUpdateDetails: {
                    uniqueId: segmentId,
                    keywordInclusionList: keywordsIncFile
                      ? keywordsIncFile.keywordsInc[0]
                      : null,
                  },
                },
              })
                .then(() => {
                  window.location.reload();
                })
                .catch((err) => {
                  setErrors("Error updating segment: " + err.message);
                })
            }
          >
            Submit
          </Button>
        </Flex>
      </Collapse>
    </Flex>
  );
};
